module.exports = __webpack_public_path__ + "img/uni-logos-mobile.e98e8ed4.png";